import React, { useState, useEffect, useMemo } from "react";
import { Button, Spinner, Alert, Card, Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaEye, FaTrash } from "react-icons/fa";
// import { getAppliedRoleListForDrCr} from "../../../services/api";

import { getAdminAuditions } from "../../../services/adminApi";
import DataTable from "../../../components/DataTable";

const AdminAuditionsList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const res = await getAdminAuditions();
      const raw = res.data.data || [];

      const mapped = raw.map((item) => ({
        id: item.roleApplicationId,

        roleId: item.roleId,
        // applicationId: item.roleApplicationId,
         applicationId: item.applicationId, 
       roleApplicationId: item.roleApplicationId,

        candidateName: item.candidateName,
        castingDirector: item.castingDirector,
        roleName: item.roleName,

        auditionType: item.auditionType,
        paymentStatus: item.paymentStatus,
        paymentId: item.paymentId,

        date: item.auditionDate,
        month: item.auditionMonth,

        verifyStatus: item.verifyStatus,
        status: item.status
      }));

      setData(mapped);
    } catch (err) {
      setError("Failed to load data");
    } finally {
      setLoading(false);
    }
  };

//  const handleViewApp = (roleApplicationId) => {
//         navigate(`/admin/manage-applications/${roleApplicationId}`);
//     };

const handleViewApp = (roleApplicationId) => {
  console.log("CLICK ID:", roleApplicationId); // 🔥 check here

  if (!roleApplicationId) {
    alert("ID missing bro!");
    return;
  }

  navigate(`/admin/manage-applications/${roleApplicationId}`);
};


  // ✅ COLUMNS SAME STYLE
  const columns = useMemo(() => [
    {
      accessorKey: "index",
      header: "#",
      cell: (info) => info.row.index + 1
    },
    {
      accessorKey: "roleId",
      header: "Role ID"
    },
    {
      accessorKey: "applicationId",
      header: "Application ID"
    },
    {
      accessorKey: "candidateName",
      header: "Candidate"
    },
    {
      accessorKey: "castingDirector",
      header: "Casting Director"
    },
    {
      accessorKey: "roleName",
      header: "Role"
    },
    {
      accessorKey: "auditionType",
      header: "Audition Type",
      cell: (info) => <Badge bg="info">{info.getValue()}</Badge>
    },
    {
      accessorKey: "paymentStatus",
      header: "Payment",
      cell: (info) => (
        <Badge bg={info.getValue() === "BOOKED" ? "success" : "warning"}>
          {info.getValue()}
        </Badge>
      )
    },
    {
      accessorKey: "paymentId",
      header: "Payment ID"
    },
    {
      accessorKey: "date",
      header: "Date"
    },
    {
      accessorKey: "month",
      header: "Month"
    },
    {
      accessorKey: "verifyStatus",
      header: "Verify"
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: (info) => (
        <Badge bg="secondary">{info.getValue()}</Badge>
      )
    },

    {
        id: "actions",
        header: "Action",
        cell: (info) => {
            const appId = info.row.original.roleApplicationId; // ✅ correct ID

            return (
            <Button
                variant="link"
                className="text-white"
                onClick={() => handleViewApp(appId)}
            >
                <FaEye />
            </Button>
            );
        }
    }
  ], []);

  // ✅ MOBILE CARD
  const renderMobile = (item) => (
    <Card key={item.id} className="mb-3 bg-dark text-white">
      <Card.Body>
        <h6>{item.candidateName}</h6>
        <p>{item.roleName}</p>
        <Badge bg="info">{item.auditionType}</Badge>

        <div className="mt-2 d-flex gap-2">
          <Button size="sm"  onClick={() => handleViewApp(item.applicationId)} > <FaEye /> View </Button>
          {/* <Button size="sm" variant="danger">
            <FaTrash />
          </Button> */}
        </div>
      </Card.Body>
    </Card>
  );

  if (loading) return <Spinner />;

  return (
    <div>
      {error && <Alert variant="danger">{error}</Alert>}

    <div style={{ overflowX: "auto" }}>
      <DataTable
        columns={columns}
        data={data}
        renderMobileItem={renderMobile}
        searchPlaceholder="Search..."
      />
      </div>
    </div>
  );
};

export default AdminAuditionsList;